export default "__VITE_ASSET__s9QOOcfN__"